/**
 * Texts for User Training page - Spanish
 */
export const userTrainingPageText = {
    title: 'Capacitación de usuario - CamAPS FX',
    titleMeta: 'Recursos de capacitación completos para usuarios de CamAPS FX',
    descriptionMeta: 'Acceda a materiales de capacitación completos, tutoriales en video, guías de usuario y seminarios web para aprovechar al máximo CamAPS FX.',
    keywords:
        'capacitación camaps fx, capacitación camaps, capacitación diabetes, capacitación bomba insulina, guía usuario, tutoriales video',
    localeMeta: 'es_es',

    mainHeader: 'Capacitación de usuario',
    mainSubHeader: 'Complete la capacitación esencial en la aplicación antes de usar la aplicación CamAPS FX.',

    gettingStartedHeader: 'Primeros pasos',
    step1Title: '<strong>Paso 1:</strong><br/>Descargue la aplicación',
    step2Title: '<strong>Paso 2:</strong><br/>Cree una cuenta',
    step3Title: '<strong>Paso 3:</strong><br/>Comience la capacitación esencial en la aplicación',
    step4Title: '<strong>Paso 4:</strong><br/>Empareje con su bomba y CGM elegidos (con la aprobación de su equipo de atención médica) o explore la aplicación con <strong>modo virtual</strong>',
    videoSrc: '/video/In-app training loop_1.mp4', // Path to video in public folder

    supportSectionTitle: '¿Necesita ayuda para instalar la aplicación?',
    supportSectionText: 'Visite nuestra sección de soporte para obtener orientación',
    supportButtonText: 'APOYO',
    findOutMoreButtonText: 'MÁS INFORMACIÓN',

    additionalResourcesTitle: 'Recursos adicionales',
    additionalResourcesSubtitle: 'Aprenda a través de imágenes paso a paso o vea sesiones dirigidas por expertos sobre el uso de la aplicación.',
    
    animationsTitle: 'Animaciones',
    animationsDescription: 'La bomba de insulina Dana solo está disponible comercialmente con CamAPS FX en el Reino Unido en este momento. Todos los recursos relacionados con Dana están disponibles solo en inglés.',
    animationsLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    
    webinarsTitle: 'Seminarios web',
    webinarsDescription: 'Estos seminarios web son adecuados para personas que viven con diabetes tipo 1, sus familiares y cuidadores, así como para maestros, personal de apoyo educativo y profesionales de la salud. Se ofrecen en inglés.',
    webinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    factsheetsTitle: 'Hojas informativas',
    factsheetsDescription: 'La bomba de insulina Dana solo está disponible comercialmente con CamAPS FX en el Reino Unido en este momento. Todos los recursos relacionados con Dana están disponibles solo en inglés.',
    factsheetsLink: 'https://www.camdiabtraining.com',

    inAppTrainingHeader: 'Capacitación en la aplicación',
    inAppTrainingText: 'Comience con la capacitación esencial integrada en la aplicación CamAPS FX. Esta capacitación interactiva lo guiará a través de todas las funciones clave que necesita conocer.<br/><br/><strong>Para acceder:</strong> Descargue la aplicación CamAPS FX y cree una cuenta para comenzar su capacitación en la aplicación.',

    gettingStartedText: '<strong>Paso 1:</strong> Descargue la aplicación CamAPS FX de la tienda de aplicaciones de su dispositivo<br/><strong>Paso 2:</strong> Cree su cuenta<br/><strong>Paso 3:</strong> Complete los módulos de capacitación en la aplicación<br/><strong>Paso 4:</strong> Conecte su bomba de insulina y CGM<br/><strong>Paso 5:</strong> Comience su viaje con CamAPS FX',

    trainingResourcesHeader: 'Recursos de capacitación adicionales',
    videoTutorialsText: 'Tutoriales en video',
    videoTutorialsDesc: 'Vea guías en video paso a paso que cubren la configuración, el uso diario y la solución de problemas.',
    videoTutorialsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    userGuidesText: 'Guías de usuario y documentación',
    userGuidesDesc: 'Descargue guías PDF completas y materiales de referencia rápida.',
    userGuidesLink: 'https://www.camdiabtraining.com',
    
    webinarsText: 'Seminarios web en vivo',
    webinarsDesc: 'Únase a sesiones de capacitación dirigidas por expertos y oportunidades de preguntas y respuestas.',

    needHelpHeader: '¿Necesita ayuda?',
    needHelpTextStart: 'Si necesita ayuda o tiene preguntas, visite nuestra página de',
    supportLinkText: 'Soporte',
    needHelpTextEnd: 'para obtener ayuda adicional e información de contacto.'
};

